import React from "react";
import { Modal, Button, Stack, Typography } from "@mui/joy";
import ModalSheet from "./common/ModalSheet";

interface VideoOptionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onRecordVideo: () => void;
  onUploadVideo: () => void;
}

const VideoOptionsModal: React.FC<VideoOptionsModalProps> = ({
  isOpen,
  onClose,
  onRecordVideo,
  onUploadVideo,
}) => {
  const handleUploadClick = () => {
    onUploadVideo();
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "none",
          },
        },
      }}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: ["flex-end", "center"],
        p: 0,
        border: "none",
      }}
    >
      <ModalSheet sx={{ height: { xs: "44vh", sm: "19rem" } }}>
        <Typography
          level="modalHeading"
          sx={{ ml: { xs: "16px", md: "40px" }, mt: "20px" }}
        >
          Send us a video
        </Typography>
        <Typography level="description" sx={{ mb: "24px", mx: { xs: "16px", md: "40px" } }}>Tell us where you have worked but mostly, tell us about you.</Typography>

        <Stack
          direction="column"
          alignItems="center"
          spacing={{ xs: 3, md: 4, mb: 16 }}
        >
          <Button
            onClick={onRecordVideo}
            sx={{
              width: { xs: "95%", md: "85%" },
              height: "52px",
              py: { md: 2 },
              backgroundColor: "#2E2D7E",
              color: "#ffffff",
              fontSize: { xs: "1rem", md: "1.125rem" },
              fontWeight: 600,
              borderRadius: "16px",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#42418a",
              },
              transition: "background-color 0.2s",
            }}
          >
            Record Video
          </Button>

          <Button
            onClick={handleUploadClick}
            sx={{
              width: { xs: "95%", md: "85%" },
              height: "52px",
              py: { md: 2 },
              backgroundColor: "#f4f4f4",
              color: "#2e2d7e",
              fontSize: { xs: "1rem", md: "1.125rem" },
              fontWeight: 600,
              borderRadius: "16px",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#e4e4e9",
              },
              transition: "background-color 0.2s",
            }}
          >
            Upload Video from Gallery
          </Button>
        </Stack>
      </ModalSheet>
    </Modal>
  );
};

export default VideoOptionsModal;
